"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var cxs_1 = tslib_1.__importDefault(require("cxs"));
var lodash_1 = require("lodash");
var react_1 = tslib_1.__importDefault(require("react"));
var content_shifter_1 = tslib_1.__importDefault(require("./content-shifter/content-shifter"));
var content_slider_1 = tslib_1.__importDefault(require("../content-slider/content-slider"));
var page_list_1 = tslib_1.__importDefault(require("../page-list/page-list"));
var button_1 = tslib_1.__importDefault(require("../nav/button/button"));
var inline_icon_1 = tslib_1.__importDefault(require("../inline-icon/inline-icon"));
var keyboard_navigation_1 = tslib_1.__importDefault(require("./keyboard-navigation/keyboard-navigation"));
var wrapper_1 = tslib_1.__importDefault(require("./wrapper/wrapper"));
var main_item_watcher_1 = tslib_1.__importDefault(require("./main-item-watcher/main-item-watcher"));
var item_loading_1 = tslib_1.__importDefault(require("./item-loading/item-loading"));
var accessibility_focus_1 = tslib_1.__importDefault(require("../../utils/accessibility-focus"));
var slider_scss_1 = tslib_1.__importDefault(require("./styles/slider.scss"));
var ArrowLeftShadyIcon_1 = tslib_1.__importDefault(require("../../../icons/compiled/components/ArrowLeftShadyIcon"));
var round = function (number) { return Math.floor(number * 100) / 100; };
var FAKE_ITEM_ID_PREFIX = 'fake';
var DEFAULT_VIDEOS_COUNT = 8;
var Slider = /** @class */ (function (_super) {
    tslib_1.__extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.loadMore = (0, lodash_1.debounce)(function (itemsCount) {
            var _a = _this.props, loadMoreItems = _a.loadMoreItems, canLoadMoreItems = _a.canLoadMoreItems;
            if (canLoadMoreItems) {
                loadMoreItems(itemsCount);
            }
        }, 300);
        _this.getVisibleItemsCount = function () {
            return _this.state.firstItemAtFrameIndex + _this.props.inFrameItemsCount;
        };
        _this.getMissingItemsCount = function () {
            return Math.max(0, _this.getVisibleItemsCount() - _this.props.loadedItemsCount);
        };
        _this.isPrevButtonVisible = function () {
            if (!_this.state.mounted) {
                return false;
            }
            return (_this.state.firstItemAtFrameIndex > 0 || _this.state.isLastItemForcedInView);
        };
        _this.isLastPage = function () { return _this.getVisibleItemsCount() === _this.props.itemsCount; };
        _this.isLastItemPartiallyVisible = function () {
            var _a = _this.props, width = _a.width, itemWidthWithSpacing = _a.itemWidthWithSpacing, horizontalSpacing = _a.horizontalSpacing, inFrameItemsCount = _a.inFrameItemsCount;
            var minWidthNeeded = inFrameItemsCount * itemWidthWithSpacing - horizontalSpacing;
            return (_this.isLastPage() &&
                !_this.state.isLastItemForcedInView &&
                width < minWidthNeeded);
        };
        _this.isLeftArrowVisible = function () {
            return _this.props.isRTL ? _this.isNextButtonVisible() : _this.isPrevButtonVisible();
        };
        _this.isRightArrowVisible = function () {
            return _this.props.isRTL ? _this.isPrevButtonVisible() : _this.isNextButtonVisible();
        };
        _this.isNextButtonVisible = function () {
            if (!_this.state.mounted) {
                return false;
            }
            return (_this.isLastItemPartiallyVisible() ||
                _this.getVisibleItemsCount() < _this.props.itemsCount);
        };
        _this.updateState = function (nextState) {
            _this.setState(tslib_1.__assign(tslib_1.__assign({}, nextState), { isTransitioning: true }));
        };
        _this.setFirstItemAtFrameIndex = function (firstItemAtFrameIndex) {
            _this.updateState({ firstItemAtFrameIndex: firstItemAtFrameIndex });
        };
        _this.setLastItemForcedInView = function (isLastItemForcedInView) {
            _this.updateState({ isLastItemForcedInView: isLastItemForcedInView });
        };
        _this.focusContainer = function () {
            // Timeout - wait for content update
            setTimeout(function () {
                (0, accessibility_focus_1.default)(_this.containerRef);
            }, 10);
        };
        _this.saveContainerRef = function (ref) { return (_this.containerRef = ref); };
        _this.handleKeyboardLeftClick = function () {
            if (_this.isLeftArrowVisible()) {
                _this.handleLeftArrowClick(true);
            }
        };
        _this.handleKeyboardRightClick = function () {
            if (_this.isRightArrowVisible()) {
                _this.handleRightArrowClick(true);
            }
        };
        _this.handleLeftArrowClick = function (isSourceKeyboard) {
            return _this.props.isRTL
                ? _this.goToNextPage(isSourceKeyboard)
                : _this.goToPrevPage(isSourceKeyboard);
        };
        _this.handleRightArrowClick = function (isSourceKeyboard) {
            return _this.props.isRTL
                ? _this.goToPrevPage(isSourceKeyboard)
                : _this.goToNextPage(isSourceKeyboard);
        };
        _this.getNextPageIndex = function (shiftCount) {
            var _a = _this.props, itemsCount = _a.itemsCount, inFrameItemsCount = _a.inFrameItemsCount;
            return (0, lodash_1.clamp)(_this.state.firstItemAtFrameIndex + shiftCount, 0, itemsCount - inFrameItemsCount);
        };
        _this.goToPrevPage = function (isSourceKeyboard) {
            var _a = _this.props, onPageChange = _a.onPageChange, itemsPerPageCount = _a.itemsPerPageCount;
            if (_this.state.isLastItemForcedInView) {
                _this.setLastItemForcedInView(false);
                return;
            }
            _this.updateState({
                firstItemAtFrameIndex: _this.getNextPageIndex(-itemsPerPageCount),
                isLastItemForcedInView: false,
            });
            onPageChange();
            if (isSourceKeyboard) {
                return;
            }
            _this.focusContainer();
        };
        _this.goToNextPage = function (isSourceKeyboard) {
            var _a = _this.props, onPageChange = _a.onPageChange, itemsPerPageCount = _a.itemsPerPageCount, withDisabledNav = _a.withDisabledNav;
            if (withDisabledNav) {
                return;
            }
            var nextFirstItemAtFrameIndex = _this.getNextPageIndex(itemsPerPageCount);
            _this.updateState({
                firstItemAtFrameIndex: nextFirstItemAtFrameIndex,
                isLastItemForcedInView: nextFirstItemAtFrameIndex === _this.state.firstItemAtFrameIndex,
            });
            onPageChange();
            if (isSourceKeyboard) {
                return;
            }
            _this.focusContainer();
        };
        _this.checkItemVisible = function (itemIndex) {
            var inFrameItemsCount = _this.props.inFrameItemsCount;
            var firstItemAtFrameIndex = _this.state.firstItemAtFrameIndex;
            return (itemIndex >= firstItemAtFrameIndex &&
                itemIndex < firstItemAtFrameIndex + inFrameItemsCount);
        };
        _this.renderItem = function (itemId) {
            var _a = _this.props, horizontalSpacing = _a.horizontalSpacing, loaderTheme = _a.loaderTheme, thumbnailHeight = _a.thumbnailHeight;
            return (react_1.default.createElement("div", { key: itemId, className: slider_scss_1.default.item, style: { margin: "0 ".concat(round(horizontalSpacing / 2), "px") } }, (0, lodash_1.startsWith)(itemId, FAKE_ITEM_ID_PREFIX) ? (react_1.default.createElement(item_loading_1.default, { style: { height: thumbnailHeight }, active: !_this.state.isTransitioning, theme: loaderTheme })) : (_this.renderItemWithOverlay(itemId))));
        };
        _this.saveActiveItemRef = function (ref) {
            _this.activeItemRef = ref;
        };
        _this.isActiveItem = function (itemId) {
            return (0, lodash_1.indexOf)(_this.props.itemIds, itemId) === _this.props.mainItemIndex;
        };
        _this.isActiveItemOutOfFrame = function () {
            var _a = _this.props, mainItemIndex = _a.mainItemIndex, inFrameItemsCount = _a.inFrameItemsCount;
            var firstItemAtFrameIndex = _this.state.firstItemAtFrameIndex;
            var bounds = [
                firstItemAtFrameIndex,
                firstItemAtFrameIndex + inFrameItemsCount - 1,
            ];
            return mainItemIndex < bounds[0] || mainItemIndex > bounds[1];
        };
        _this.handleTransitionEnd = function () {
            _this.setState({ isTransitioning: false });
            _this.props.onTransitionEnd();
        };
        _this.saveActiveItemOverlayRef = function (ref) {
            _this.activeItemOverlayRef = ref;
        };
        _this.state = {
            firstItemAtFrameIndex: 0,
            isLastItemForcedInView: false,
            isTransitioning: false,
            isAnimationDisabled: false,
            mounted: false,
        };
        return _this;
    }
    Slider.prototype.componentDidMount = function () {
        this.setState({
            mounted: true,
        });
    };
    Slider.prototype.UNSAFE_componentWillReceiveProps = function (_a) {
        var reset = _a.reset, itemsCount = _a.itemsCount, mainItemIndex = _a.mainItemIndex;
        if (reset && this.state.firstItemAtFrameIndex) {
            // TODO: looks silly...
            this.setState({
                firstItemAtFrameIndex: 0,
                isLastItemForcedInView: false,
            });
            return;
        }
        if (mainItemIndex >= 0 && this.activeItemRef && this.activeItemOverlayRef) {
            if (!this.activeItemRef.contains(this.activeItemOverlayRef)) {
                this.activeItemRef.appendChild(this.activeItemOverlayRef);
            }
        }
        this.handleItemsCountReduced(itemsCount);
    };
    Slider.prototype.componentDidUpdate = function () {
        var missingItemsCount = this.getMissingItemsCount();
        if (missingItemsCount && this.props.canLoadMoreItems) {
            this.loadMore(missingItemsCount);
        }
        if (this.isActiveItemOutOfFrame()) {
            this.props.onActiveItemLeftFrame();
        }
    };
    Slider.prototype.handleItemsCountReduced = function (itemsCount) {
        var _this = this;
        var difference = this.props.itemsCount - itemsCount;
        if (difference > 0 && this.isLastPage()) {
            this.setState({
                firstItemAtFrameIndex: Math.max(0, this.state.firstItemAtFrameIndex - difference),
                isAnimationDisabled: true,
            }, function () {
                _this.setState({
                    isAnimationDisabled: false,
                });
            });
        }
    };
    Slider.prototype.renderItemWithOverlay = function (itemId) {
        var renderItem = this.props.renderItem;
        var isActive = this.isActiveItem(itemId);
        return (react_1.default.createElement("div", tslib_1.__assign({}, (isActive && { ref: this.saveActiveItemRef })), renderItem(itemId, this.checkItemVisible)));
    };
    Slider.prototype.shouldRenderShadyArrow = function () {
        var _a = this.props, withArrowsOutside = _a.withArrowsOutside, withShadyNavigation = _a.withShadyNavigation;
        return !withArrowsOutside && withShadyNavigation;
    };
    Slider.prototype.getCustomNavArrow = function () {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(slider_scss_1.default.shadyNavButton, this.props.shadyNavButtonClassName) },
            react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(ArrowLeftShadyIcon_1.default, null) })));
    };
    Slider.prototype.renderActiveItemOverlay = function () {
        return react_1.default.cloneElement(this.props.activeItemOverlay, {
            ref: this.saveActiveItemOverlayRef,
        });
    };
    Slider.prototype.render = function () {
        var _a, _b;
        var _c = this.props, width = _c.width, itemWidth = _c.itemWidth, itemWidthWithSpacing = _c.itemWidthWithSpacing, className = _c.className, thumbnailHeight = _c.thumbnailHeight, navButtonClassName = _c.navButtonClassName, navButtonStyle = _c.navButtonStyle, mainItemIndex = _c.mainItemIndex, itemsPerPageCount = _c.itemsPerPageCount, preloadedPagesCount = _c.preloadedPagesCount, accessibilityLabels = _c.accessibilityLabels, horizontalSpacing = _c.horizontalSpacing, withArrowsOutside = _c.withArrowsOutside, withNavAlwaysVisible = _c.withNavAlwaysVisible, inFrameItemsCount = _c.inFrameItemsCount, isConnectedToMainItemIndex = _c.isConnectedToMainItemIndex, withKeyboardNavigation = _c.withKeyboardNavigation, withShadyNavigation = _c.withShadyNavigation, virtualPages = _c.virtualPages, activeItemOverlay = _c.activeItemOverlay, isRTL = _c.isRTL, containerStyle = _c.containerStyle;
        var _d = this.state, firstItemAtFrameIndex = _d.firstItemAtFrameIndex, isLastItemForcedInView = _d.isLastItemForcedInView, isAnimationDisabled = _d.isAnimationDisabled;
        var prevButtonAriaLabel = accessibilityLabels.prevButtonAriaLabel, nextButtonAriaLabel = accessibilityLabels.nextButtonAriaLabel;
        var containerClassNames = (0, classnames_1.default)(slider_scss_1.default.container, className, (_a = {},
            _a[slider_scss_1.default['has-hover-gradient']] = !withArrowsOutside && !withShadyNavigation,
            _a[slider_scss_1.default['has-shady-arrows']] = withShadyNavigation && !withArrowsOutside,
            _a[slider_scss_1.default['has-always-visible-nav']] = withNavAlwaysVisible,
            _a[slider_scss_1.default['has-nav-prev']] = this.isLeftArrowVisible(),
            _a[slider_scss_1.default['has-nav-next']] = this.isRightArrowVisible(),
            _a[slider_scss_1.default.rtl] = isRTL,
            _a));
        var gradientNavOverlayHeight = {
            height: "".concat(thumbnailHeight, "px !important"),
        };
        var pseudoHeightClassName = (0, cxs_1.default)({
            '::after': gradientNavOverlayHeight,
            '::before': gradientNavOverlayHeight,
        });
        var prerenderItemsCount = inFrameItemsCount + itemsPerPageCount * preloadedPagesCount;
        var preRenderedCount = typeof window === 'undefined'
            ? Math.max(DEFAULT_VIDEOS_COUNT, prerenderItemsCount)
            : prerenderItemsCount;
        var customNavArrow = this.getCustomNavArrow();
        return (react_1.default.createElement(wrapper_1.default, { style: containerStyle, ariaLabel: accessibilityLabels.containerAriaLabel, itemWidth: itemWidth, className: (0, classnames_1.default)(containerClassNames, (_b = {},
                _b[pseudoHeightClassName] = thumbnailHeight,
                _b)), onRef: this.saveContainerRef, isRTL: isRTL },
            withKeyboardNavigation && (react_1.default.createElement(keyboard_navigation_1.default, { onKeyboardArrowLeft: this.handleKeyboardLeftClick, onKeyboardArrowRight: this.handleKeyboardRightClick })),
            isConnectedToMainItemIndex && (react_1.default.createElement(main_item_watcher_1.default, { firstItemAtFrameIndex: firstItemAtFrameIndex, inFrameItemsCount: inFrameItemsCount, mainItemIndex: mainItemIndex, onFirstItemIndexUpdate: this.setFirstItemAtFrameIndex, onForceLastItemUpdate: this.setLastItemForcedInView })),
            react_1.default.createElement("div", { className: navButtonClassName, style: navButtonStyle }, this.isLeftArrowVisible() && (react_1.default.createElement(button_1.default, tslib_1.__assign({ className: slider_scss_1.default.prev, style: { height: thumbnailHeight } }, (this.shouldRenderShadyArrow() && {
                arrowIcon: customNavArrow,
            }), { ariaLabel: isRTL ? nextButtonAriaLabel : prevButtonAriaLabel, dataHook: isRTL ? 'next-button' : 'prev-button', onClick: this.handleLeftArrowClick })))),
            react_1.default.createElement(content_slider_1.default, { dataHook: "content-slider", disabled: isAnimationDisabled, onTransitionEnd: this.handleTransitionEnd, width: itemWidthWithSpacing, currentPageNumber: firstItemAtFrameIndex, isRTL: isRTL },
                react_1.default.createElement(content_shifter_1.default, { width: width, reduceMarginsBy: round(horizontalSpacing / 2), itemWidth: itemWidthWithSpacing, inFrameItemsCount: inFrameItemsCount, active: isLastItemForcedInView, isRTL: isRTL },
                    react_1.default.createElement(page_list_1.default, { pageWidth: itemWidthWithSpacing, preRenderedCount: preRenderedCount, currentPageNumber: firstItemAtFrameIndex, itemsByPageNumber: virtualPages, renderItem: this.renderItem }))),
            react_1.default.createElement("div", { className: navButtonClassName, style: navButtonStyle }, this.isRightArrowVisible() && (react_1.default.createElement(button_1.default, tslib_1.__assign({ className: slider_scss_1.default.next, style: { height: thumbnailHeight }, ariaLabel: isRTL ? prevButtonAriaLabel : nextButtonAriaLabel }, (this.shouldRenderShadyArrow() && {
                arrowIcon: customNavArrow,
            }), { dataHook: isRTL ? 'prev-button' : 'next-button', onClick: this.handleRightArrowClick })))),
            activeItemOverlay && this.renderActiveItemOverlay()));
    };
    Slider.defaultProps = {
        onPageChange: lodash_1.noop,
        onTransitionEnd: lodash_1.noop,
        onActiveItemLeftFrame: lodash_1.noop,
    };
    return Slider;
}(react_1.default.Component));
var SliderInterface = function (props) {
    var width = props.width, itemWidth = props.itemWidth, horizontalSpacing = props.horizontalSpacing, itemIds = props.itemIds, itemsCount = props.itemsCount, mainItemIndex = props.mainItemIndex;
    var itemWidthWithSpacing = itemWidth + horizontalSpacing;
    var inFrameItemsCount = Math.ceil(width / itemWidthWithSpacing);
    var calculatedProps = tslib_1.__assign(tslib_1.__assign({}, props), { inFrameItemsCount: inFrameItemsCount, itemWidthWithSpacing: itemWidthWithSpacing, loadedItemsCount: (0, lodash_1.size)(itemIds), isConnectedToMainItemIndex: !(0, lodash_1.isUndefined)(mainItemIndex), virtualPages: (0, lodash_1.chunk)((0, lodash_1.assign)((0, lodash_1.map)((0, lodash_1.range)(0, itemsCount), function (value) { return "".concat(FAKE_ITEM_ID_PREFIX, "-").concat(value); }), itemIds), 1) });
    return react_1.default.createElement(Slider, tslib_1.__assign({}, calculatedProps));
};
SliderInterface.defaultProps = {
    itemsPerPageCount: 3,
    preloadedPagesCount: 2,
    horizontalSpacing: 0,
    withArrowsOutside: false,
    withNavAlwaysVisible: false,
    withDisabledNav: false,
    withKeyboardNavigation: false,
    withShadyNavigation: false,
};
exports.default = SliderInterface;
//# sourceMappingURL=slider.js.map